import "@ceyper-common/src/lib/style/theme.css";
import "@ceyper-common/src/lib/style/input.css";

import "@ceyper-common";
import App from "./App.svelte";
import "$lib/commands";
import { mount } from "svelte";

(window as any).clear = () => {
    localStorage.clear();
    location.reload();
};

let app;

try {
    app = mount(App, { target: document.body });
} catch (e) {
    console.error(e);
    confirm("Clear local cache?") && (window as any).clear();
    app = null!;
}

document.body.classList.add("loaded");

export default app;
